import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ShoppingCart } from "lucide-react";
import { PlanStorage } from "@/lib/plan-storage";
import { useAuth } from "@/lib/auth";

interface PlanToggleButtonProps {
  onClick: () => void;
  className?: string;
}

export default function PlanToggleButton({ onClick, className }: PlanToggleButtonProps) {
  const { user } = useAuth();
  const [showCount, setShowCount] = useState(0);

  // Update show count
  useEffect(() => {
    const updateCount = () => {
      const count = PlanStorage.getShowCount(user?.id);
      setShowCount(count);
    };

    updateCount();
    
    // Listen for storage changes
    const handleStorageChange = () => updateCount();
    window.addEventListener('storage', handleStorageChange);
    
    // Check for updates periodically (in case of same-tab changes)
    const interval = setInterval(updateCount, 1000);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [user?.id]);

  if (showCount === 0) return null;

  return (
    <div className={`hidden lg:block ${className}`}>
      <Button
        onClick={onClick}
        className="fixed bottom-6 right-6 z-30 h-14 px-4 bg-primary hover:bg-primary/90 shadow-lg hover:shadow-xl transition-all duration-200"
      >
        <div className="flex items-center gap-2">
          <div className="relative">
            <ShoppingCart className="w-5 h-5" />
            <Badge className="absolute -top-2 -right-2 min-w-[1.25rem] h-5 flex items-center justify-center text-xs bg-red-500 text-white px-1">
              {showCount}
            </Badge>
          </div>
          <span className="font-medium">Plan Builder</span>
        </div>
      </Button>
    </div>
  );
}